import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./styles.scss";

export const NotFound = (): JSX.Element => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="nf">
      <h1>404</h1>
      <h3>Oops, looks like festival ends here for now...</h3>
      <Link to="/">
        <button type="button">Go home</button>
      </Link>
    </div>
  );
};
